import React from 'react';
import PerceptionsAssignedSection from './PerceptionsAssignedSection';
import DeductionsAssignedSection from './DeductionsAssignedSection';
import PayrollSummaryCards from './PayrollSummaryCards';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const PeriodDetail = ({ row }) => {
    return (
        <>
            <PayrollSummaryCards data={row} />
            <div className='row'>
                <div className='col-sm-12 col-md-6 px-1 minw-0'>
                    <PerceptionsAssignedSection id={row?.id} row={row} />
                </div>
                <div className='col-sm-12 col-md-6 px-1 minw-0'>
                    <DeductionsAssignedSection id={row?.id} />
                </div>
            </div>
        </>
    );
};

export default PeriodDetail;
